<script>
import InputRadio from '../../atoms/inputlib/components/InputRadio'
export default {
    name: 'RadioLine',
    components: { InputRadio },
    props: {
        value: null,
        data: null,
        hintText: null,
        required: Boolean,
        disabled: Boolean,
        readonly: Boolean,
        allowEmpty: Boolean,
        reverse: Boolean,
    },
    methods: {
        onInput() {
            if (!this.disabled) this.$emit('input', this.data)
        },
    },
}
</script>

<template lang="pug">
.radio-line-wrapper(:class="{'extend': $slots.extend, 'disabled': disabled}")
    .radio-line(@click="onInput" :class="{'disabled': disabled, 'mb-0': $slots.extend, 'reverse': reverse}")
        slot
        span.ml-auto.mr-2.text-73.text-sm(v-if="$slots.info")
            slot(name="info")
        input-radio(v-if="!$slots.radioIcon" 
            :value="value" 
            @input="onInput" 
            :data="data"
            :hint-text="hintText" 
            :required="required" 
            :disabled="disabled" 
            :readonly="readonly" 
            :allow-empty="allowEmpty")
        slot(name="radioIcon")
    .extend-block(v-if="$slots.extend")
        slot(name="extend")
</template>
